import * as errors from "../errors.js";
import { state } from "../state.js";

/*
    ABS evaluates to the absolute value (value without the sign) of the given numeric term.
    The numeric parameter has to be a floating point number. If the term is not numeric, the BASIC error ?TYPE MISMATCH ERROR occurs.
    When the numeric argument is absent, it displays a ?SYNTAX ERROR. 
*/
export const abs = async (args) => {
    // Example of valid args:
    // ABS(-10) (Screen: 10)
    // ABS(-10-11+5) (Screen: 16)
    // ABS("Text") (Screen: ?TYPE MISMATCH  ERROR)
    // ABS() (Screen: ?SYNTAX  ERROR)
    // Check if args are a number or a mathematical expression.

    // If no args are given, throw a syntax error.
    if (args.length === 0) {
        throw new errors.SyntaxError();
    }

    if (Math.abs(args) > state.maxValue) {
        throw new errors.OverflowError();
    }

    // Check if the args is a number.
    if (isNaN(args)) {
        throw new errors.TypeMismatchError();
    }

    const result = Math.abs(args);

    // Check if the result is within the range of a floating point value.
    if (result > state.maxValue) {
        throw new errors.OverflowError();
    }

    // Return the absolute value of the result.
    return result;
};